import CommentsAction from './CommentsAction.container';

export default CommentsAction;
